import {SmartComponent} from "smart-component-js";
import $ from "jquery";
import product from "../data/product";
import Constants from "../business/Constants";

class ProductsComponent extends SmartComponent {

	constructor(element, parentComponent, params) {
		super(element, parentComponent, params);
		this.init();
	}

	prepareProducts() {
		$('.show-products').on('click', function() {
			$('.products-wrapper').scrollTop(0);
			$('.products-wrapper').fadeIn();
			$('body').addClass('noScroll');
		});

		$('.products-close').on('click', function() {
			$('.products-wrapper').fadeOut();
			$('body').removeClass('noScroll');
		})
	}

	buildProductsList() {
		let productsListStructure = `
		<div class="products-wrapper" style="display: none;">
			<div class="product-close-wrapper content-wrapper-cnt">
				<div class="products-close">
					<svg>
						<use xlink:href="#svg_circle_close"></use>
					</svg>
				</div>
			</div>
			<div class="products-title">Trovi 1 punto colazione nei seguenti prodotti</div>
			<div class="products-list content-wrapper-cnt">
			</div>
		</div>`;
		$('.mb-promo').append(productsListStructure);
	}

	retrieveProducts() {
		$.each(product.response.data, function() {
			let productCard = `
				<a class="product-item" href="https://mulinobianco.it/${this.link}?yxp-from-promo=${Constants.PROMO_CODE}" target="_blank">
					<img class="product-img" src="${this.image}"></img>
					<div class="product-title">${this.title}</div>
				</a> 
			`;
			$('.products-list').append(productCard);
		})
	}

	init() {
		this.buildProductsList();
		this.retrieveProducts();
		this.prepareProducts();
	}
}

export default ProductsComponent;